"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInANZSelector = exports.countrySelector = void 0;

var countrySelector = function countrySelector(_ref) {
  var country = _ref.country;
  return country;
};

exports.countrySelector = countrySelector;

var isInANZSelector = function isInANZSelector(state) {
  var country = countrySelector(state);
  return country === 'australia' || country === 'new zealand';
};

exports.isInANZSelector = isInANZSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CountrySelectors.js
// module id = 266
// module chunks = 5 6 7